export const RulesetFilterListData = [
	{ label: 'Sender', value: 0 },
	{ label: 'Received', value: 1 },
	{ label: 'Recipient', value: 2 },
	{ label: 'Mailboxes Type', value: 3 },
	{ label: 'In Folder', value: 4 },
	{ label: 'Has Tag', value: 5 },
];
